import { createGlobalStyle } from 'styled-components';

export const TableStyles = createGlobalStyle`
.sds-reset-style{
  circle#gris-icon,circle#red-icon,
  circle#blue-icon,circle#orange-icon,
  circle#green-icon,circle#black-icon,
  circle[id^=do-couleur],circle[id^=pr-couleur],circle[id^=ecp-couleur],circle[id^=indus-couleur],circle[id^=milieu-couleur],circle[id^=pluie-couleur] {
    r:5;
  }}
`;

export const FilterStyles = createGlobalStyle`

.sds-reset-style{
  .filterForm{
    .sds-container.sds-m-card {
  overflow: visible !important;
}
    margin-bottom: 2%;
    .radio-check{
    justify-content: space-between;
    width: 33%;
    }
    .rowContainer{
    flex-direction: row;
    justify-content:space-between;
    .colContainer{
      width:48%;
      .dropdown-icon-container path{
        fill: #008BD2;
      }
      span.sds-word.normalItalic{
        color: #696969;
        font-size: 11px;
      }
    }
    }
  }
}`;
